export function numFormat(num) {
  if (num === null) return "—";
  // //console.log(num, Number(num).toLocaleString(), num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'), 111);
  var c =
    num.toString().indexOf(".") !== -1
      ? Number(num).toLocaleString()
      : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  return c;
}
